import { render, staticRenderFns } from "./AwsComplianceBanner.vue?vue&type=template&id=84af108c&scoped=true&"
import script from "./AwsComplianceBanner.vue?vue&type=script&lang=js&"
export * from "./AwsComplianceBanner.vue?vue&type=script&lang=js&"
import style0 from "./AwsComplianceBanner.vue?vue&type=style&index=0&id=84af108c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84af108c",
  null
  
)

export default component.exports